import type { FC } from 'react';

import ServicesGroupView from 'components/UI/organisms/ServicesGroupView/ServicesGroupView';

const ServicesGroupPage: FC = () => <ServicesGroupView />;

export default ServicesGroupPage;
